export { CompanyInfoItem, CompanyInfoItemProps } from './CompanyInfoItem';
